import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemRecycleMode extends Cloneable {
    static DISABLED = new ItemRecycleMode(0, "DISABLED");
    static COLLECTOR = new ItemRecycleMode(1, "COLLECTOR");
    static TRASH = new ItemRecycleMode(2, "TRASH");
    static MIXED = new ItemRecycleMode(3, "MIXED");

    static _values = [
        this.DISABLED,
        this.COLLECTOR,
        this.TRASH,
        this.MIXED
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemRecycleMode.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemRecycleMode) {
            return ItemRecycleMode._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "DISABLED") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemRecycleMode) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemRecycleMode());
        } else if (target instanceof ItemRecycleMode) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemRecycleMode, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});